module.exports = __webpack_public_path__ + "img/winning_form-logo_black2.5718df96.svg";